<template>
  <el-container class='box'>
    <div class="headerCom">
      <div class="text"><span>运营管理 / </span><span>外链链接 / </span><span>渠道管理</span></div>
      <el-form ref="searchForms" :model="searchParams" inline size="small">
        <el-form-item>
          <el-select v-model="searchParams.applyType" placeholder="请选择搜索类型" class="filter-item"
            @change="applyTypeChange">
            <el-option label="渠道名称" value="1" />
            <el-option label="状态" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="searchParams.applyType == 1">
          <el-input placeholder="请输入渠道名称" prefix-icon="el-icon-search" v-model.trim="searchParams.name" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item v-if="searchParams.applyType == 2">
          <el-select v-model="searchParams.enabled" clearable class="selectinput" placeholder="请选择状态" @change="selectChange"  @clear="setValueNull">
            <el-option v-for="(item, index) in statusArr" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-tag class="a-tag" size="small" closable @close="tagClose(1)"
          v-if="searchParamsNew.name && searchParamsNew.name != ''">
          {{ searchParamsNew.name }}
        </el-tag>
        <el-tag class="a-tag" size="small" closable @close="tagClose(2)"
          v-if="searchParamsNew.enabled == true || searchParamsNew.enabled == false">
          <span v-if="searchParamsNew.enabled == 1">启用</span>
          <span v-if="searchParamsNew.enabled == 0">禁用</span>
        </el-tag>
        <el-form-item>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchFrom">搜索</el-button>
        </el-form-item>
        <el-button style="float:right" type="primary" size="small" @click="addColumn">+新增渠道</el-button>
      </el-form>
    </div>
    <el-main class="listTabel">
      <el-table :data="tableData" :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px'
			}">
        <el-table-column align="center" prop="name" label="渠道名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.enabled?'启用':'禁用'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="createTime" label="添加时间" min-width="100px">
        </el-table-column>
        <el-table-column align="center" prop="updateUserName" label="操作人">
        </el-table-column>
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.enabled" @click="disableClick(scope.row)">
              禁用
            </el-button>
            <el-button type="text" size="small" v-else @click="enableTheClick(scope.row)">
              启用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
    <el-dialog :title="dialogTitle" width="760px" :visible="dialogStatus" :close-on-click-modal="false"
      @close="handleClose">
      <!-- :visible="bannerDialogStatus" ref="backFormRef" -->
      <div class="dialog-main-content">
        <el-form ref="purposeForm" :model="purposeForm" :rules="purposeFormRules" label-position="right">
          <el-form-item prop="name">
            <el-input placeholder="请输入渠道名称" v-model.trim="purposeForm.name" maxlength="20" show-word-limit
              style="width:80%;">
              <!-- :rows="3" -->
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="handleReset"
          >重置</el-button
        > -->
        <el-button type="primary" @click="handleConfirm">确认添加</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { insertReturnId, page, publish } from "./api/channelManagement";
import { DEEP_CLONE } from '@/utils/constants'
export default {
  components: {},
  props: {},
  data() {
    return {
      searchParams: {
        size: 10,
        current: 1,
        applyType: null,
        name: null,
        enabled: null
      },
      searchParamsNew: { 
        size: 10,
        current: 1,
        applyType: null,
        name: null,
        enabled: null
      },
      tableData: [],
      total: 0,
      statusArr: [
        {
          label: "启用",
          id: 1
        },
        {
          label: "禁用",
          id: 0
        }
      ],
      purposeForm: {
        name: null //渠道名称
      },
      purposeFormRules: {
        // 判断弹窗数据验证
        name: [
          {
            required: true,
            message: "请输入渠道名称",
            trigger: "blur"
          }
        ]
      },
      dialogTitle: "渠道管理",
      dialogStatus: false,
      total: 0
    };
  },
  watch: {},
  computed: {},
  created() {
    this.channelManagementListRequest();
  },
  mounted() {},
  methods: {
    enableTheClick(row) {
      //启用
      publish({ id: row.id }).then(res => {
        if (res.code == 0) {
          this.channelManagementListRequest();
          this.$message.success("启用成功");
        }
      });
    },
    disableClick(row) {
      //禁用
      publish({ id: row.id }).then(res => {
        if (res.code == 0) {
          this.channelManagementListRequest();
          this.$message.success("禁用成功");
        }
      });
    },
    handleSizeChange(value) {
      this.searchParams.size = value;
      this.channelManagementListRequest();
    },
    handleCurrentChange(value) {
      this.searchParams.current = value;
      this.channelManagementListRequest();
    },
    resetForm() {
      this.searchParams.size = 10;
      this.searchParams.current = 1;
      (this.searchParams.name = null), (this.searchParams.enabled = null);
      (this.searchParams.applyType = null);
      let searchParamsNew = DEEP_CLONE(this.searchParams)
      this.searchParamsNew = searchParamsNew;
      this.channelManagementListRequest();
    },
    searchFrom() {
      this.searchParams.size = 10;
      this.searchParams.current = 1;
      let searchParamsNew = DEEP_CLONE(this.searchParams)
      this.searchParamsNew = searchParamsNew;
      this.channelManagementListRequest();
    },
    addColumn() {
      this.dialogStatus = true;
      this.purposeForm.name = null;
      this.$forceUpdate();
    },
    selectMethod() {},
    handleConfirm() {
      //弹窗确认按钮
      this.$refs.purposeForm.validate(valid => {
        console.log(valid, "valid");
        if (valid) {
          insertReturnId(this.purposeForm).then(res => {
            if (res.code == 0) {
              this.channelManagementListRequest();
              this.$message.success("添加成功");
              this.dialogStatus = false;
            }
          });
        }
      });
    },
    handleClose() {
      this.$refs["purposeForm"].clearValidate();
      this.dialogStatus = false;
    },
    channelManagementListRequest() {
      page(this.searchParams).then(res => {
        if (res.code == 0) {
          if (res.data && res.data.records.length > 0) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },
    tagClose(v) {
      if (v == 1) {
        this.searchParams.name = null;
        this.searchParamsNew.name = null;
      }
      if (v == 2) {
        this.searchParams.enabled = null;
        this.searchParamsNew.enabled = null;
      }
      this.searchParams.size = 10;
      this.searchParams.current = 1;
      this.channelManagementListRequest();
    },
    applyTypeChange() {},
    selectChange(){
      // this.searchParamsNew.enabled = '';
      console.log(this.searchParamsNew,"this.searchParamsNew");
      // this.searchParamsNew.enabled = this.searchParams.enabled
    },
    setValueNull(e){
      console.log(e,"eee");
      this.searchParams.enabled = null;
        // this.searchParamsNew.status = null;
    },
  }
};
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}
/deep/.el-form-item__content {
  text-align: center;
}
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.el-form-item__error {
  left: 73px;
}
/deep/.el-tag{
    margin:9px 5px 0 0;
  }
</style>